import { FC, useMemo } from 'react';


import { useApplication } from '@eneco/common/application';
import useDC from '@eneco/dc/useDC';
import { useMachine } from '@xstate/react';

import { Layout } from './Layout/Layout';
import { getMeterReadingFlowMachine, MeterReadingsFlowMachine } from './state/MeterReadingsFlow.machine';

const MeterReadingsFlow: FC = () => {
  const authenticationContext = useDC();
  const { searchParams } = useApplication();

  const readingId = Number(searchParams.get('opnamekenmerk')) || null;
  const houseNumber = Number(searchParams.get('huisnummer')) || null;

  const machine = useMemo(
    () =>
      getMeterReadingFlowMachine({
        authenticationContext: authenticationContext,
        readingId,
        houseNumber,
      }),
    [authenticationContext, readingId, houseNumber],
  );

  const [state, send] = useMachine(machine);

  const contextValue = useMemo(() => ({ state, send }), [state, send]);

  return (
    <MeterReadingsFlowMachine.Provider value={contextValue}>
      <Layout />
    </MeterReadingsFlowMachine.Provider>
  );
};

export default MeterReadingsFlow;
